import type { EventItem } from '@/features/publicsite/types/events/EventItem';
import type { EventTimeline } from '@/features/publicsite/types/events/EventTimeline';

/**
 * The calendar the way a visitor reads it (tor.md §6.11): what is still to come, soonest first,
 * then what has already happened, most recent first. It used to be one list in start order, so an
 * event from last week sat among next week's with nothing to tell them apart.
 *
 * `past` is the server's (EventService.hasTakenPlace — the rule that also closes registration), so
 * nothing here reads the visitor's clock; the API answers in start order, which the upcoming half
 * keeps and the past half turns round.
 */
export function splitTimeline<T extends Pick<EventItem, 'past'>>(events: T[]): EventTimeline<T> {
  return {
    upcoming: events.filter((e) => !e.past),
    past: events.filter((e) => e.past).reverse(),
  };
}
